// extracted by mini-css-extract-plugin
export default {"container":"infoTooltip_container__LUa4J","icon":"infoTooltip_icon__Gm38+"};